"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Subscription = exports.SubscriptionStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_ContactPoint_1 = require("./RTTI_ContactPoint");
var RTTI_instant_1 = require("../Scalar/RTTI_instant");
var RTTI_Subscription_Channel_1 = require("./RTTI_Subscription_Channel");
var SubscriptionStatusKind;
(function (SubscriptionStatusKind) {
    SubscriptionStatusKind["_requested"] = "requested";
    SubscriptionStatusKind["_active"] = "active";
    SubscriptionStatusKind["_error"] = "error";
    SubscriptionStatusKind["_off"] = "off";
})(SubscriptionStatusKind = exports.SubscriptionStatusKind || (exports.SubscriptionStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Subscription = t.recursion('ISubscription', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Subscription'),
            channel: RTTI_Subscription_Channel_1.RTTI_Subscription_Channel
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            status: (0, EnumType_1.createEnumType)(SubscriptionStatusKind, 'SubscriptionStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            contact: t.array(RTTI_ContactPoint_1.RTTI_ContactPoint),
            end: RTTI_instant_1.RTTI_instant,
            _end: RTTI_Element_1.RTTI_Element,
            reason: t.string,
            _reason: RTTI_Element_1.RTTI_Element,
            criteria: t.string,
            _criteria: RTTI_Element_1.RTTI_Element,
            error: t.string,
            _error: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_Subscription.js.map